export default "__VITE_ASSET__BK1cSllG__"